/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type ProductCarousel_viewer = {
    readonly videoUploadToolsFeatureFlag: boolean | null;
    readonly " $refType": "ProductCarousel_viewer";
};
export type ProductCarousel_viewer$data = ProductCarousel_viewer;
export type ProductCarousel_viewer$key = {
    readonly " $data"?: ProductCarousel_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProductCarousel_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductCarousel_viewer",
  "selections": [
    {
      "alias": "videoUploadToolsFeatureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "videoUploadTools"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"videoUploadTools\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'cbb6e4973231426288b342479e6beabb';
export default node;
